import React from 'react';

import { InputMask } from 'utils/inputMask';
import { Select } from 'components/uikit/Form/Select/Select';
import { TextInputMasked } from 'components/uikit/Form/TextInputMasked/TextInputMasked';
import { Button } from 'components/uikit/Button/Button';

import { useManualAddressFormPresenter } from './ManualAddressForm.presenter';
import * as S from './ManualAddressForm.styles';

const fn = () => {};

export const ManualAddressForm = ({
  initData,
  title = '',
  tooltip = '',
  onSave = fn,
  onCancel = fn,
}) => {
  const presenter = useManualAddressFormPresenter({ initData, onSave, onCancel });

  return (
    <S.Wrapper>
      {title && (
        <S.Title>
          {title}
          <S.InfoIcon ref={presenter.hintRef} />
          <S.TooltipHoverStyled targetRef={presenter.hintRef} theme="2" size="m" position="top">
            {tooltip}
          </S.TooltipHoverStyled>
        </S.Title>
      )}
      <S.Row>
        <S.DaDataAddressInput
          label="Регион"
          type="address"
          error={presenter.errors?.regionName || presenter.errors?.regionFiasId || ''}
          additionalData={presenter.daDataAdditionalData.region}
          value={presenter.region}
          onChange={presenter.regionChangeHandler}
          theme="2"
        />
        <TextInputMasked
          name="index"
          label="Почтовый индекс"
          mask={InputMask.INDEX_LAZY}
          unmask
          value={presenter.localData?.index || ''}
          autoFocus={false}
          onChange={presenter.localDataChangeHandler}
          error={presenter.errors?.index || ''}
          theme="2"
        />
      </S.Row>

      <S.Row>
        <S.DaDataAddressInput
          label="Район"
          type="address"
          error={presenter.errors?.districtName || presenter.errors?.districtKladrCode || ''}
          additionalData={presenter.daDataAdditionalData.district}
          value={presenter.district}
          onChange={presenter.districtChangeHandler}
          theme="2"
        />
        <div ref={presenter.cityNameRef}>
          <S.DaDataAddressInput
            label="Город"
            type="address"
            error={presenter.errors?.cityName || presenter.errors?.cityFiasId || ''}
            disabled={presenter.isCityNameDisabled}
            additionalData={presenter.daDataAdditionalData.city}
            value={presenter.city}
            onChange={presenter.cityChangeHandler}
            theme="2"
          />
          {presenter.isCityNameDisabled && (
            <S.TooltipHoverStyled
              targetRef={presenter.cityNameRef}
              theme="2"
              size="m"
              position="top"
            >
              Чтобы указать город, очистите поле &quot;Населенный пункт&quot;
            </S.TooltipHoverStyled>
          )}
        </div>
      </S.Row>

      <S.Row joined>
        <Select
          name="settlementType"
          placeholder="Тип населенного пункта"
          defaultValue={presenter.settlementType}
          value={presenter.settlementType?.id}
          list={presenter.settlementTypesList}
          onChange={presenter.settlementTypeChangeHandler}
          search
          error={presenter.errors?.settlementType || ''}
          disabled={presenter.isSettlementTypeDisabled}
        />

        <div ref={presenter.settlementNameRef}>
          <TextInputMasked
            name="settlementName"
            label="Название населенного пункта"
            mask={InputMask.ADDRESS_RUS_STRICT}
            unmask
            value={presenter.localData?.settlementName || ''}
            autoFocus={false}
            onChange={presenter.localDataChangeHandler}
            error={presenter.errors?.settlementName || ''}
            disabled={presenter.isSettlementNameDisabled}
            theme="2"
          />
          {presenter.isSettlementNameDisabled && (
            <S.TooltipHoverStyled
              targetRef={presenter.settlementNameRef}
              theme="2"
              size="m"
              position="top"
            >
              Чтобы указать населенный пункт, очистите поле &quot;Город&quot;
            </S.TooltipHoverStyled>
          )}
        </div>
      </S.Row>

      <S.Row joined>
        <Select
          name="streetType"
          placeholder="Тип улицы"
          defaultValue={presenter.streetType}
          value={presenter.streetType?.id}
          list={presenter.streetTypesList}
          onChange={presenter.streetTypeChangeHandler}
          search
          error={presenter.errors?.streetType || ''}
        />

        <TextInputMasked
          name="streetName"
          label="Название улицы"
          mask={InputMask.ADDRESS_RUS_STRICT}
          unmask
          value={presenter.localData?.streetName || ''}
          autoFocus={false}
          onChange={presenter.localDataChangeHandler}
          error={presenter.errors?.streetName || ''}
          theme="2"
        />
      </S.Row>

      <S.Row joined>
        <Select
          name="houseType"
          placeholder="Тип дома"
          defaultValue={presenter.houseType}
          value={presenter.houseType?.id}
          list={presenter.houseTypesList}
          onChange={presenter.houseTypeChangeHandler}
          search
          error={presenter.errors?.houseType || ''}
        />

        <TextInputMasked
          name="houseNumber"
          label="Номер дома"
          mask={InputMask.ADDRESS_RUS_STRICT}
          unmask
          value={presenter.localData?.houseNumber || ''}
          autoFocus={false}
          onChange={presenter.localDataChangeHandler}
          error={presenter.errors?.houseNumber || ''}
          theme="2"
        />
      </S.Row>

      <S.Row joined>
        <Select
          name="buildingType"
          placeholder="Тип корпуса/строения"
          defaultValue={presenter.buildingType}
          value={presenter.buildingType?.id}
          list={presenter.buildingTypesList}
          onChange={presenter.buildingTypeChangeHandler}
          search
          error={presenter.errors?.buildingType || ''}
        />

        <TextInputMasked
          name="building"
          label="Номер корпуса/строения"
          mask={InputMask.ADDRESS_RUS_STRICT}
          unmask
          value={presenter.localData?.building || ''}
          autoFocus={false}
          onChange={presenter.localDataChangeHandler}
          error={presenter.errors?.building || ''}
          theme="2"
        />
      </S.Row>

      <S.Row joined>
        <Select
          name="apartmentType"
          placeholder="Тип помещения"
          defaultValue={presenter.apartmentType}
          value={presenter.apartmentType?.id}
          list={presenter.apartmentTypesList}
          onChange={presenter.apartmentTypeChangeHandler}
          search
          error={presenter.errors?.apartmentType || ''}
        />

        <TextInputMasked
          name="apartmentNumber"
          label="Номер помещения"
          mask={InputMask.ADDRESS_RUS_STRICT}
          unmask
          value={presenter.localData?.apartmentNumber || ''}
          autoFocus={false}
          onChange={presenter.localDataChangeHandler}
          error={presenter.errors?.apartmentNumber || ''}
          theme="2"
        />
      </S.Row>

      <S.Controls>
        <Button onClick={presenter.cancelHandler} theme={3} size="m">
          Отменить
        </Button>
        <Button onClick={presenter.saveHandler} size="m">
          Сохранить
        </Button>
      </S.Controls>
    </S.Wrapper>
  );
};
